export interface IPatientCaseRejectionReasonHF {
  patientCaseId?: string;
  hfId?: string;
  rrHfId?: string;
  description?: string;
  patientCase?: any;
  healthcareFacility?: any;
  rejectionReasonHF?: any;
}

export const defaultValue: Readonly<IPatientCaseRejectionReasonHF> = {};
